import classes from './Card.module.css';

const Card = props => {
  return <div className={`${classes.card} h-100`}>{props.children}</div>
};

export default Card;